<template>
  <div
    :class="className"
    class="status"
  >
    <span
      v-if="showIcon"
      class="status__icon"
    >
      <i
        :class="icon"
        class="icon"
      />
    </span>
    <span class="status__label">
      <slot />
    </span>
  </div>
</template>

<script>
export default {
  props: {
    showIcon: {
      type: Boolean,
      required: false,
      default: false,
    },
    module: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    modules: {
      news: [
        { label: 'Active', className: 'status--green', icon: 'icon-progress' },
        { label: 'Expired', className: 'status--grey', icon: 'icon-c-delete' },
        { label: 'Incoming', className: 'status--yellow', icon: 'icon-c-check' },
      ],
    },
  }),
  computed: {
    className () {
      return this.modules[this.module].find(item => item.label === this.value).className
    },
    icon () {
      return this.modules[this.module].find(item => item.label === this.value).icon
    },
  },
}
</script>
